import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'
import UserProfile from './Components/Profil/User/UserProfile.jsx'

import actions from '../../components/CurrentUserLoader/actions.js'
import conf from '../../../shared/conf.js'

class MyProfileFreelanceContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  onFormSuccess = () => {}

  refresh = (profile) => {}

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, ...rest} = this.props
    if (!endLoadingCurrentUser || !currentFreelance) {
      return null
    }

    return (
      <StrategyFreelanceContainer
        currentUser={currentUser}
        isOwner={!!currentUser}
        loading={!endLoadingCurrentUser}
        navbar={true}
        onFormSuccess={this.onFormSuccess}
        profile={{user: currentUser, freelance: currentFreelance}}
        refresh={this.refresh}
        wrapWithLayout={true}
        view={UserProfile}
        {...rest}
      />
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(MyProfileFreelanceContainer, conf.accountTypes.freelance))